import React from 'react';
//internal and external components import
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import { TableRow, Checkbox, Chip, TextField, ThemeProvider, createTheme, Tooltip, Typography,InputAdornment  } from '@mui/material';
import { stableSort, getComparator } from '../../common/SortSupport';
import { EnhancedTableHead } from '../EnhancedTableHead';
import { Box } from '@mui/material';
import ActionDetailPopper from '../../containers/ActionDetailPopper';
import { teams } from '../../assets/staticData';
import YenTextField from '../YenTextField';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark, faCheck, faTrash } from '@fortawesome/free-solid-svg-icons';
import MultiSelectPrimary from '../MultiSelectPrimary';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { deleteTitle } from '../../api/dataCapture';
import YearSelector from '../YearSelector';
import { formatToYear } from '../../common/StaticExports';

const theme = createTheme({
  components: {
    MuiStack: {
      styleOverrides: {
        root: {
          display: 'inline',
          width: '90px'
        }
      }
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          minWidth: '90px !important',
        }
      }
    },
    MuiInputBase: {
      styleOverrides: {
        input: {
          fontSize: 12
        }
      }
    },
    MuiSvgIcon: {
      styleOverrides: {
        root: {
          width: 18,
          height: 18
        }
      }
    }
  },
})

const TitlesTable = (props?: any) => {
    const { addData, handleClick, manageState } = props;

  //supporting contents
  const [order, setOrder] = React.useState('');
  const [orderBy, setOrderBy] = React.useState('');
  const data = useSelector((state:any) => state.dataCaptures.selectedTeam)?.titles;
  const [newData, setNewData] = React.useState<any>({});
  const [t] = useTranslation();
  const isAdmin = useSelector((state:any) => state.common.isAdmin);

  const handleRequestSort = (
    event: React.MouseEvent<unknown>,
    property: any,
  ) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const visibleRows = React.useMemo(
    () =>
      data?.length > 0 &&
      stableSort(data, getComparator(order, orderBy)),
    [order, orderBy, data],
  );

  const head = [
    {key: '', displayName: t('DC_7_COMPETITION').toUpperCase()},
    {key: '', displayName: t('DC_7_YEAR_ACHIEVED').toUpperCase()},
    {key: '', displayName: ''},
  ]

  const manageChange = (updatedRow:any) => {
    const updatedList = data?.map((row: any) => {
      if (row.id === updatedRow.id) {
        return updatedRow;
      }
      return row;
    });
    manageState(updatedList);
  }

  const manageCreatenew = () => {
    if (newData?.competition) {
      const updatedList = [{...newData, tempId: Math.random()}, ...data];
      manageState(updatedList);
      setNewData({});
      handleClick();
    }
  }
  
  const manageDeleteRow = (row: any) => {
    if (row?.id) {
      deleteTitle({ id: row?.id });
    }
    const updatedList = data?.filter((d:any) => (d?.id != row?.id || d?.tempId != row?.tempId));
    manageState(updatedList);
  }

  //table contents
    return(
        <React.Fragment>
          <ThemeProvider theme={theme}>
          <Box sx={{ position: 'relative' }}>
              <TableContainer sx={{ maxHeight: '34vh', overflowY: 'auto' }}>
                <Table stickyHeader size="small" aria-label="a dense table">
                    <EnhancedTableHead
                    order={order}
                    orderBy={orderBy}
                    onRequestSort={handleRequestSort}
                    tableHeads={head}
                    />
                    <TableBody>
                      {
                        !isAdmin && addData &&
                        <TableRow
                        sx={{ cursor: 'pointer' }}
                        key={`history-table-row-add-data`}
                        >
                            <TableCell className='fs12'>
                              <TextField 
                              variant='standard' 
                              sx={{ width: '100%' }} 
                              value={newData?.competition}
                              onChange={(e: any) => setNewData({...newData, competition: e.target.value})}/>
                            </TableCell>
                            <TableCell className='fs12'>
                              <YearSelector
                                value={newData?.yearAchieved}
                                manageSelect={(e:any) => setNewData({...newData, yearAchieved: parseInt(formatToYear(e))})}/>
                            </TableCell>
                            <TableCell>
                              <Tooltip title='Delete' arrow placement='top'>
                                <FontAwesomeIcon onClick={() => {handleClick(); setNewData({});}} className={'icon mr10'} icon={faXmark}/>
                              </Tooltip>
                              <Tooltip title='Create' arrow placement='top'>
                                <FontAwesomeIcon className={'icon mr10'} icon={faCheck} onClick={manageCreatenew}/>
                              </Tooltip>
                            </TableCell>
                        </TableRow>
                      }
                    {
                        visibleRows && visibleRows?.length &&
                        visibleRows?.map((d: any, i: number) => (
                        <TableRow
                        sx={{ cursor: 'pointer' }}
                        key={`history-table-row-${i}`}
                        >
                            <TableCell className='fs12'>
                                <TextField 
                                variant='standard' 
                                sx={{ width: '100%' }} 
                                value={d?.competition}
                                onChange={(e: any) => manageChange({...d, competition: e.target.value})}
                                disabled={isAdmin}/>
                            </TableCell>
                            <TableCell className='fs12'>
                              <YearSelector
                                value={d?.yearAchieved}
                                manageSelect={(e:any) => manageChange({...d, yearAchieved: parseInt(formatToYear(e))})}
                                isReadOnly={isAdmin}/>
                            </TableCell>
                            <TableCell className='fs12'>
                              <Tooltip title='Delete' arrow placement='top'>
                                <FontAwesomeIcon onClick={() => {!isAdmin && manageDeleteRow(d)}} className={isAdmin ? 'icon mr10 deleteIcon cursorNotAllowed' : 'icon mr10 deleteIcon'} icon={faTrash}/>
                              </Tooltip>
                            </TableCell>
                        </TableRow>
                    ))}
                    </TableBody>
                </Table>
              </TableContainer>
            </Box>
          </ThemeProvider>
        </React.Fragment>
    )
}

export default TitlesTable;